export function Footer() {
  return (
    <footer className="bg-black text-[#999999] h-[120px] flex items-center border-t border-white/5">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[14px] font-sans font-normal text-center md:text-left">
            &copy; 2025 OFM Elite Mentoria — Lucas de Alencar. Todos os direitos
            reservados.
          </p>

          <div className="flex gap-8 text-[14px] font-sans font-normal">
            <a
              href="#"
              className="hover:text-[#FF6B00] transition-colors duration-200"
            >
              Termos de Uso
            </a>
            <a
              href="#"
              className="hover:text-[#FF6B00] transition-colors duration-200"
            >
              Política de Privacidade
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
